module.exports = __webpack_public_path__ + "img/other2.0d982971.png";